export default __webpack_public_path__ + "static/media/lookinggood.db2a17dd.jpg";